export const USERS_AND_PERMISSIONS_MODAL = 'UsersAndPermissions'
export const IP_ADD_EDIT_MODAL = 'IpAddEditModal'
